import React from "react";
import * as R from "ramda";
import SelectFilter from "../../components/tableComponents/selectFilter";
import Sort, { SortValType } from "../../components/tableComponents/sort";
import { option } from "../../components/singleSelectMain/helper";

export type TextTableHeaderType = {
  title: string;
  propName: string;
  options: option[];
  sortFilter?: SortValType | null;
  setSortFilter?: (a: SortValType) => void;
  filters?: any;
  style?: any;
  setFilter?: (a: any) => void;
};

export const TextTableHeader = ({
  title,
  propName,
  options,
  sortFilter = null,
  style = {},
  setSortFilter = () => true,
  filters = null,
  setFilter = () => true
}: TextTableHeaderType) => {
  return (
    <th className="tableFilterHeader">
      <div style={style}>
        <span>
          {title}
          {sortFilter ? (
            <Sort
              propName={propName}
              sortColumn={
                sortFilter || {
                  column: null,
                  direction: null
                }
              }
              sortColumnFunc={setSortFilter}
            />
          ) : null}
        </span>
        {R.has(propName, filters) ? (
          <SelectFilter
            propKey={propName}
            filters={filters}
            onChange={setFilter}
            options={options}
            selectClassName="config"
          />
        ) : null}
      </div>
    </th>
  );
};

export default TextTableHeader;
